import React from "react";
import BasicLayout from "../../layouts/BasicLayout";
import { SetMenus } from "../../constants/SetMenu";

const SetMenu = () => {
  return (
    <div className="mt-8">
      <BasicLayout>
        <div className="grid grid-cols-12 text-center">
          {SetMenus.map((item, index) => {
            return (
              <div key={index} className="lg:col-span-6 col-span-12 mb-10">
                <div
                  className="bg-no-repeat  w-full h-[550px] bg-contain relative bg-center"
                  style={{
                    backgroundImage:
                      "url(https://png.pngtree.com/background/20210711/original/pngtree-simple-recipe-menu-design-psd-background-map-picture-image_1073919.jpg)",
                  }}
                >
                  <div className="absolute left-[50%] translate-x-[-50%] text-left top-10 bg-[#dbbd7d]">
                    <h2 className="font-bold text-lg text-center">
                      {item.name}
                    </h2>
                    <h2 className="font-bold text-[#ff0000] text-center">
                      ---{item.price}k---
                    </h2>
                    {item.title && (
                      <h2 className="font-semibold text-[#ff0000] text-center">
                        ({item.title})
                      </h2>
                    )}
                    {item.foods.map((item) => {
                      return (
                        <div
                          key={item.name}
                          className="mt-[6px] font-semibold text-[#2b2b2b] text-[15px] text-nowrap"
                        >
                          <span className="">{item.name}.</span>
                          {item.price !== 0 && (
                            <span className=""> / {item.price}k</span>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}

          <div className="lg:col-span-6 col-span-12"></div>
        </div>
      </BasicLayout>
    </div>
  );
};

export default SetMenu;
